var _style, _line, _line2, _line3, _line4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalControlByShooterAutoReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.4,
    y1: 8,
    x2: 4.8,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.9,
    y1: 8,
    x2: 8.3,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.7,
    y1: 8,
    x2: 12,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.2,
    y1: 8,
    x2: 15.5,
    y2: 8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0.5,4.7 2.4,4.7 2.4,11.3 0.5,11.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalControlByShooterAutoReturn);
export default __webpack_public_path__ + "static/media/MechanicalControlByShooterAutoReturn.389b20dd23686a9583f66c0a0f3a7461.svg";
export { ForwardRef as ReactComponent };